import { useEffect, useState } from "react";
import { getNotesURL } from "../utils/ConstantsURL";

export const fetchNotasDesdeAPI = async (
  token,
  selectedDate,
  selectedIdSection,
  idDocument
) => {
  const response = await fetch(
    getNotesURL(selectedDate, selectedIdSection, idDocument),
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.message || "Ocurrió un error al obtener las notas."
    );
  }

  return await response.json();
};

export const useFetchNotas = (
  token,
  selectedDate,
  selectedIdSection,
  refresh,
  idDocument
) => {
  const [notas, setNotas] = useState([]);
  const [loadingNote, setLoadingNote] = useState(false);

  useEffect(() => {
    const fetchNotas = async () => {
      if (!token || !selectedDate || !selectedIdSection || !idDocument) {
        setNotas([]);
        setLoadingNote(false);
        return;
      }

      setLoadingNote(true);
      try {
        const data = await fetchNotasDesdeAPI(
          token,
          selectedDate,
          selectedIdSection,
          idDocument
        );
        setNotas(data);
      } catch (error) {
        setNotas([]);
        console.error(error);
      } finally {
        setLoadingNote(false);
      }
    };

    fetchNotas();
  }, [token, selectedDate, selectedIdSection, refresh, idDocument]);

  return { notas, loadingNote };
};
